import React  from 'react';
import ProfessionalCovenants from './ProfessionalCovenants';
import ProfessionalName from './ProfessionalName';
import ProfessionalSpecialities from './ProfessionalSpecialities';

const InformationProfessional = ({ professional }) => {

    return (
        <>
            <ProfessionalName nameProfessional={professional.ptdNombre} />
            <div style={{ marginBottom: '16px' }}>
                <ProfessionalSpecialities specialities={professional.especialidades} />
            </div>
            <ProfessionalCovenants covenants={professional.convenios} />
        </>
    )
}

export default InformationProfessional
